import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
} from '@mui/material';

import { Popup } from 'components';
import { callApi } from 'utils';
import { t } from 'i18n';

const PresetDids = ({args, onClose}) => {
  const [msgs, setMsgs] = useState([]);
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!args)
      return;

    const sse = new EventSource(`/api/sse/asyncmsgs?sid=${args.sid}`);
    sse.addEventListener("start",     (ev) => setMsgs([ev.data]));
    sse.addEventListener("reconnect", (ev) => setMsgs(prev => [...prev, `* ${ev.data}`]));
    sse.addEventListener("message",   (ev) => setMsgs(prev => [...prev, ...JSON.parse(ev.data)]));
    sse.addEventListener("end", (ev) => {
      setMsgs(prev => [...prev, `*** Result: ${ev.data}`]);
      if (ev.data === 'success') {
        setN(prev => {
          prev > 0 && sse.close();
          return prev + 1;
        });
      } else {
        sse.close();
      }
    });

    return () => {
      sse.close();
      setN(0);  // reset for next job
    };
  }, [args]);

  const execPrepSql = () => {
    setN(prev => prev + 1);
    callApi(`/jobs/execprepsql?sid=${args.sid}`).then((res) => {
      console.log(res);
    }).catch(console.error);
  };

  if (!args)
    return null;

  return (
    <Popup
      open={Boolean(args)}
      onClose={onClose}
      title={`Fcid: ${args.fcid} / 任务: ${args.jobs} / 最近分区: ${args.lastp} / 筛选: ${args.flt || t('All Devices')}`}
      styles={{minWidth: '600px', maxHeight: '90%'}}
    >
      <Typography sx={{mt: 1, whiteSpace: "pre-wrap"}}>{msgs.join('\n')}</Typography>
      {n === 1 && (<Button variant="outlined" onClick={execPrepSql} sx={{mt:1}}>执行 SQL</Button>)}
    </Popup>
  );
};

export default PresetDids;
